import React, { useState } from 'react'
import { Contract } from '../../../../../types/contract'
import { ContractActivation } from '../ContractActivation'
import { ChangeContractDialog } from '../../subscriptions/dialogs/common/ChangeContractDialog'
import { ContractPaymentInfoBanner } from '../../subscriptions/ContractPaymentBanner'
import { translations } from '../../../../../utils/translations/translations-manager'
export function ContractActivationDialog({
  contract,
  visible,
  close,
  success,
}: {
  contract: Contract
  visible: boolean
  close: () => void
  success: () => void
}): JSX.Element {
  if (!contract.charityId || !contract._id) throw new Error('Charity ID and Contract ID must be defined')
  // Completed used to handle right closing the dialog after the change was successful as success
  const [completed, setCompleted] = useState(false)

  return (
    <ChangeContractDialog
      visible={visible}
      close={completed ? success : close}
      title={completed ? translations.texts.donation_updated.toString() : translations.texts.activate_recurring_donation.toString()}
    >
      <ContractActivation originalContract={contract} success={success} complete={() => setCompleted(true)} />
    </ChangeContractDialog>
  )
}
